import React, { Component } from "react";
import {
  Card,
  CardBody,
  Col, FormText,
  Row
} from "reactstrap";
import PropTypes from "prop-types";
import { metadataService } from "../../_services";
import { SlRadioButton } from "../editors";
export class SelectLoan extends Component {
  

  constructor(props) {
    super(props);
    this.loanSelected = this.loanSelected.bind(this);
    
  }

    loanSelected(e) {
    const loanId = e.target.value;
    this.props.onLoanSelected(loanId);
  }
  
  render() {

    return (
      <Card>
        <CardBody>
            <Row className="justify-content-center" >
              <Col xs={12} sm={6} md={4} lg={4}>
                        <SlRadioButton fieldName='selectLoan' value={this.props.loan.currentLoanId} disabled={this.props.loan.loanPaymentStatus >= 2}
                  isSelected={this.props.isSelected} onChange={this.loanSelected} 
                            helpText={this.props.loan.suggestedPayment ? metadataService.getFieldNameLabel("Payment") + ': ' + metadataService.formatMoney(this.props.loan.suggestedPayment) : null}>
                            {metadataService.getFieldNameLabel("CurrentLoanId")}{" "}{this.props.loan.currentLoanId}
                    <FormText>
                        {metadataService.getFieldNameLabel("Balance")}{" "}{metadataService.formatMoney(this.props.loan.balance)}
                      </FormText>
                </SlRadioButton>
              </Col>
            </Row>
        </CardBody>
      </Card>
    );
  }
}
SelectLoan.propTypes = {
    loan : PropTypes.object, 
    onLoanSelected: PropTypes.func.isRequired,
    isSelected: PropTypes.bool.isRequired
};
